import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ClipboardModule } from 'ngx-clipboard';
import { MATERIAL_MODULES } from '../../app.const';
import { PipesModule } from '../../pipes/pipes.module';
import { ApiTokenCreateDialogComponent } from './api-token-create-dialog/api-token-create-dialog.component';
import { ApiTokensRoutingModule } from './api-tokens-routing.module';
import { ApiTokensComponent } from './api-tokens.component';

@NgModule({
  declarations: [
    ApiTokensComponent,
    ApiTokenCreateDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    ClipboardModule,
    PipesModule,
    ApiTokensRoutingModule,
    ...MATERIAL_MODULES
  ]
})
export class ApiTokensModule {}
